import formatMoneyValueOnlyDigits from "components/utils/formatMoneyValueOnlyDigits";
import { palette } from "lib/miolo";
import { last } from "lodash/fp";
import type { ITotalCompensationByYear } from "types/graphqlTypes";
import Sparkline from "./adornments/Sparkline";

interface IAmericanIssuerTotalCompensationSummaryProps {
  totalCompensations: ITotalCompensationByYear[];
}

export default function AmericanIssuerTotalCompensationSummary({
  totalCompensations,
}: IAmericanIssuerTotalCompensationSummaryProps) {
  const node = last(totalCompensations);
  if (!node) {
    return null;
  }

  return (
    <div className="flex items-center space-x-8 font-aeonik">
      <div>
        <h1 className="m-0 text-xl font-bold tracking-wider text-slate-800">
          ${formatMoneyValueOnlyDigits(node.totalCompensation)}
        </h1>

        <span className="text-sm font-medium text-slate-500">Total (U.S. Dollar) • {node.fiscalYear}</span>
      </div>

      {totalCompensations.length >= 3 && (
        <Sparkline
          ariaLabel="A chart representation of the values spent in compensations for officers"
          nodes={totalCompensations.map((node) => node.totalCompensation)}
          chart={{
            margin: {
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
            },
            padding: {
              top: 4,
              left: 4,
              bottom: 4,
              right: 4,
            },
            primaryColor: palette.mariner,
            secondaryColor: palette.selago,
            width: 200,
            height: 40,
          }}
        />
      )}
    </div>
  );
}
